import {
    editEmailReminderButtonLabel,
    removeEmailReminderButtonLabel,
    remindMeLabel,
    noReminderMessageText,
} from './EmailReminderRow.locstring.json';
import { emailReminderHeader, remindAllAttendeesLabel } from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import { observer } from 'mobx-react';
import { editInboxReminder } from '../actions/draftInboxReminderActions';
import { removeInboxReminder } from '../actions/inboxRemindersActions';
import EmailReminderEntrySource from '../store/schema/EmailReminderEntrySource';
import getDisplayTextFromReminderOffset from '../utils/getDisplayTextFromReminderOffset';
import isSendOptionToAllAttendees from '../utils/isSendOptionToAllAttendees';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import { CalendarIcons } from 'owa-calendar-icons';
import { default as CalendarEvent } from 'owa-calendar-types/lib/types/CalendarEvent';
import { ControlIcons } from 'owa-control-icons';
import InboxReminderType from 'owa-service/lib/contract/InboxReminderType';

import * as React from 'react';

const styles = require('./EmailReminderRow.scss');

export interface EmailReminderRowProps {
    entrySource: EmailReminderEntrySource;
    event: CalendarEvent;
    inboxReminder: InboxReminderType;
}

@observer
export default class EmailReminderRow extends React.Component<EmailReminderRowProps, {}> {
    render() {
        const rowTitle = this.getRowTitle();
        return (
            <div className={styles.emailReminderRow}>
                <div className={styles.firstRow}>
                    <Icon
                        className={styles.reminderIcon}
                        iconName={CalendarIcons.MailReminder}
                        title={loc(emailReminderHeader)}
                    />
                    <div className={styles.rowTitle}>{rowTitle}</div>
                    <div className={styles.iconBar}>
                        <IconButton
                            iconProps={{ iconName: ControlIcons.Edit }}
                            title={loc(editEmailReminderButtonLabel)}
                            onClick={this.onEditButtonClicked}
                        />
                        <IconButton
                            className={styles.actionIcon}
                            iconProps={{ iconName: ControlIcons.Delete }}
                            title={loc(removeEmailReminderButtonLabel)}
                            onClick={this.onDeleteButtonClicked}
                        />
                    </div>
                </div>
                <div className={styles.secondRow}>{this.getMessageToDisplay()}</div>
            </div>
        );
    }

    private getRowTitle = (): string => {
        let prefix = isSendOptionToAllAttendees(this.props.inboxReminder.SendOption)
            ? loc(remindAllAttendeesLabel)
            : loc(remindMeLabel);

        const reminderDisplayString = getDisplayTextFromReminderOffset(
            this.props.inboxReminder.ReminderOffset /* reminderTimeInMinutes */,
            this.props.event.IsAllDayEvent,
            this.props.event.Start
        );

        return format('{0} {1}', prefix, reminderDisplayString);
    };

    private onEditButtonClicked = () => {
        editInboxReminder(this.props.inboxReminder, this.props.event.CalendarItemType);

        logUsage('EditEmailReminderButtonClicked');
    };

    private onDeleteButtonClicked = () => {
        removeInboxReminder(this.props.inboxReminder.Id, this.props.event, this.props.entrySource);

        logUsage('DeleteEmailReminderButtonClicked');
    };

    private getMessageToDisplay = (): string => {
        return this.props.inboxReminder.Message || format('({0})', loc(noReminderMessageText));
    };
}
